import { useEffect, useState } from "react";

// Single source of truth for "are we running inside the Mail
// desktop shell?". The bridge is injected by EnterpriseMail/desktop's
// preload script before the React app mounts, so the value is stable
// for the lifetime of the window — but we still subscribe via state so
// dev-tooling that hot-reloads the preload doesn't strand stale UI.
export function useDesktopShell() {
    const [bridge, setBridge] = useState<FowlGuardDesktopBridge | undefined>(
        () => (typeof window !== "undefined" ? window.fg : undefined)
    );

    useEffect(() => {
        if (typeof window === "undefined") return;
        if (window.fg && !bridge) setBridge(window.fg);
    }, [bridge]);

    return {
        isDesktop: bridge?.isDesktop === true,
        bridge
    };
}

// Push the unread inbox count up to the OS taskbar / dock badge. Safe
// to call from the renderer with no desktop bridge attached — falls
// through to a no-op so the same code runs in plain browser tabs.
export function setDesktopUnreadBadge(count: number): void {
    if (typeof window === "undefined") return;
    window.fg?.setUnreadBadge(count);
}

// Notification delivery moved to lib/notifications.ts so the desktop bridge and the browser
// Notification API share one implementation (this version was desktop-only, which silently dropped
// every notification in a normal browser tab). Re-exported here so existing call sites keep working.
export { pushDesktopNotification } from "./notifications";
